import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

// Pelip Brand · Pills mono uppercase con tracking-wider (label 10px · 0.14em)
const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 font-mono text-[10px] uppercase tracking-wider transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-pelip-primary/15 text-pelip-accent hover:bg-pelip-primary/25",
        secondary:
          "border-transparent bg-pelip-bg-elev-2 text-pelip-text-soft hover:bg-pelip-bg-elev-2/80",
        destructive:
          "border-transparent bg-pelip-danger/15 text-pelip-danger hover:bg-pelip-danger/25",
        outline: "border-pelip-border-strong text-pelip-text-muted hover:text-pelip-text-soft",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
